import React from 'react';
import { useAuthModal } from './useAuthModal';
import { AuthModalView } from './AuthModalView';
import { AuthAndCardModal } from '../authAndCardModal';
import { webConfig } from '../../../utils/webConfig';
import { useDonee } from '../../../api';

type AuthModalProps = {
    open: boolean;
    setOpen: (open: boolean) => unknown;
    donation: string | undefined;
};

export const AuthModal: React.FC<AuthModalProps> = ({
    open,
    setOpen,
    donation,
}) => {
    const modalState = useAuthModal(donation, setOpen);
    const { donee } = useDonee();
    const doneeName = donee?.organization.name ?? '';
    const logo = donee?.organization.logo;
    const banner = donee?.organization.banner;
    const logoUrl = logo || banner || webConfig.doneeAvatarDefault;

    return (
        <AuthAndCardModal
            onClose={(_, reason) => {
                if (reason === 'backdropClick') return;
                modalState.handleClose();
            }}
            onBack={modalState.onBack}
            donation={
                donation
                    ? {
                          amount: donation,
                          name: doneeName,
                          logoUrl: logoUrl,
                      }
                    : undefined
            }
            onCloseClick={
                modalState.step === 'recovery'
                    ? modalState.onBack
                    : modalState.handleClose
            }
            open={open}
        >
            <AuthModalView {...modalState} />
        </AuthAndCardModal>
    );
};
